import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './index';
import logger from './redux_logger';

export default function configureAppStore(preloadedState: any = undefined) {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => {
      const base = getDefaultMiddleware({ immutableCheck: false });
      const isIntegration = window.location.hostname.includes('integration');
      const isStaging = window.location.hostname.includes('staging');
      const enableLogging = process.env.NODE_ENV !== 'production' || isIntegration || isStaging;
      return enableLogging ? base.concat(logger) : base;
    },
    preloadedState,
    devTools: process.env.NODE_ENV !== 'production',
  });
}